export const QUERY_KEYS = {
  PRODUCT_DETAIL: 'productDetail',
  CREDIT_ACCOUNT_VALIDATION: 'creditAccountValidation',
  WARRANTY_TYPES: 'warrantyTypes',
  DISPATCH_BEFORE_INVOICE_ENABLED: 'dispatchBeforeInvoiceEnabled',
}
